module.exports = __webpack_public_path__ + "static/media/icon_orden_descendente.c795b2d5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icon/icon_orden_descendente.svg
// module id = 632
// module chunks = 0